import { useContext } from "react"
import { IdeaCacheContext } from "../pages/Ideas/Contexts/IdeaCacheProvider"

export const useIdeasCache = () => {
  return useContext(IdeaCacheContext)
}
